import { render, staticRenderFns } from "./g-jsonformat.vue?vue&type=template&id=8662433c&scoped=true&"
import script from "./g-jsonformat.vue?vue&type=script&lang=js&"
export * from "./g-jsonformat.vue?vue&type=script&lang=js&"
import style0 from "./g-jsonformat.vue?vue&type=style&index=0&id=8662433c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8662433c",
  null
  
)

export default component.exports